<template>
  <section class="store">
    <div class="store__header">
      <div class="store__header__content">
        <img src="static/images/notifications_store/store_header.png"/>
      </div>
    </div>
    <div class="store__content">
      <div class="store__content__head">
        <h2>{{ getTranslations.home_store_buy_games }}</h2>
        <p>{{ getTranslations.home_store_no_more_coins }}</p>
        <p>
          {{ getTranslations.home_store_get_more }}
        </p>
      </div>
      <div :class="['store__content__list ', storedBundles.length > 0 ? '' : ' store_empty' ]">
        <ul>
          <li v-for="(storeItem, index) in orderedStoreItems" :key="index">
            <div>
              <span class="">{{ storeItem.coins }} {{ getTranslations.home_store_for }}</span>
              <span> {{ storeItem.price}} {{ storeItem.currencyCode }}</span>
            </div>
            <a style="cursor: pointer"
               @click.prevent="getIt(storeItem.bundleId, storeItem.coins, storeItem.price, storeItem.currencyCode)"
               class="btn2 btn2--std btn2--small btn2--green">{{ getTranslations.home_store_get_it }}</a>
          </li>
          <li class="fb_share" v-if="facebookFunctionality">
            <div>
              <span class="">1 {{ getTranslations.home_store_for }} </span>
              <span>{{ getTranslations.home_store_ref_friend }}</span>
            </div>
            <a style="cursor:pointer"
               @click.prevent="shareFriendsInvitation()"
               class="fb_btn btn--icon">
              <i class="icon-facebook"></i>
              <span>{{ getTranslations.home_store_share }}</span>
            </a>
          </li>
        </ul>
        <span class="fb_error_msg" v-if="fb_error">{{ getTranslations.home_store_this_fb }}</span>
        <span class="store_note" v-if="vatBanner">{{ getTranslations.home_store_vat }}</span>
      </div>
    </div>
    <!-- dynamically change modals -->
    <component :is="modalForStore" @bundlePurchase="onBundlePurchase"></component>
  </section>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */

import { mapGetters, mapActions, mapState, mapMutations } from 'vuex';
import FacebookMixin from '@/common/mixins/facebookIntegration';
import ResubscribeGame from './modals/ResubscribeGame';
import ResubscribeGameSms from './modals/ResubscribeGameSms';
import ConfirmPurchase from './modals/ConfirmPurchase';
import ConfirmPurchaseForPin from './modals/ConfirmPurchaseForPin';
import ConfirmPurchaseForPinError from './modals/ConfirmPurchaseForPinError';
import ConfirmPurchaseViaSms from './modals/ConfirmPurchaseViaSms';

export default {
  name: 'store',
  mixins: [FacebookMixin],
  data() {
    return {
      points: '',
      action: 'invitation',
      fb_error: false,
      showedModal: false,
      redirectUrl: '',
    };
  },
  created() {
    this.redirectUrl = `${window.location.href}/${this.getLocale || localStorage.getItem('locale')}/`;
    if (this.facebookFunctionality) {
      this.forceFbToScrapNewMetadata(this.redirectUrl, () => {
        // eslint-disable-next-line
        console.log('successful scrapping!');
      });
    }
  },
  mounted() {
    // init google analytics (from the imported mixin)
    this.storedBundlesCall();
  },
  methods: {
    ...mapActions('profile', [
      'requestPin',
      'storedBundlesCall',
      'getUserLoginDetails',
    ]),
    ...mapMutations('profile', [
      'setBundleId',
      'setBundleData',
    ]),
    ...mapMutations('common', [
      'storeModalForStore',
    ]),
    onBundlePurchase() {
      this.getUserLoginDetails();
    },
    showError() {
      this.fb_error = true;
    },
    shareFriendsInvitation() {
      this.fb_error = false;
      this.share(
        this.userDetails.facebookId,
        this.userDetails.id,
        () => { console.log('successful share invitation!'); },
        this.showError,
      );
    },
    showModal() {
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          $('.modal, .modal-overlay').fadeOut();
          if (!this.showedModal) {
            this.showedModal = true;
            this.storeModalForStore(null);
          } else {
            this.storeModalForStore(null);
          }
        });
      });
      /* eslint-enable */
    },
    getIt(bundleId, numberOfCoins, price1, currencyCode1) {
      this.getUserLoginDetails().then(() => {
        if (this.purchaseBundleFromUnsubUser) {
          this.getBundle(bundleId, numberOfCoins, price1, currencyCode1);
        } else {
          // eslint-disable-next-line
          if (!this.userDetails.subscribed) {
            if (this.subAndUnsubViaSMS) {
              if (this.reoptinAndOptoutConfig === 'REOPTIN_SMS' || this.reoptinAndOptoutConfig === 'REOPTIN_OPTOUT_SMS') {
                this.storeModalForStore(ResubscribeGameSms);
              } else {
                this.storeModalForStore(ResubscribeGame);
              }
            } else {
              this.storeModalForStore(ResubscribeGame);
            }
            this.showModal();
          } else {
            this.getBundle(bundleId, numberOfCoins, price1, currencyCode1);
          }
        }
      });
    },
    getBundle(bundleId, numberOfCoins, price1, currencyCode1) {
      this.setBundleId(bundleId);
      const bundleData = {
        numberOfCoins,
        price: price1,
        currencyCode: currencyCode1,
      };
      this.setBundleData({ bundleDataObject: bundleData });
      if (this.purchaseViaSMS) {
        this.storeModalForStore(ConfirmPurchaseViaSms);
        this.showModal();
      } else {
        // eslint-disable-next-line
        if (this.pinForBundles) {
          const bundleInfo = {
            bundleId: this.bundleId,
          };
          this.requestPin({ value: bundleInfo }).then(() => {
            if (this.requestPinResponse === 'OPERATION_SUCCESS') {
              this.storeModalForStore(ConfirmPurchaseForPin);
              this.showModal();
            } else {
              this.storeModalForStore(ConfirmPurchaseForPinError);
              this.showModal();
            }
          });
        } else {
          this.storeModalForStore(ConfirmPurchase);
          this.showModal();
        }
      }
    },
  },
  computed: {
    ...mapState('common', [
      'purchaseBundleFromUnsubUser',
      'facebookFunctionality',
      'subAndUnsubViaSMS',
      'reoptinAndOptoutConfig',
      'pinForBundles',
      'purchaseViaSMS',
      'modalForStore',
      'userDetails',
      'vatBanner',
    ]),
    ...mapState('profile', [
      'storedBundles',
      'requestPinResponse',
      'bundleId',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getLocale',
    ]),
    orderedStoreItems() {
      // sort items by date ascending
      return this.storedBundles.slice(0).sort((a, b) => a.coins - b.coins);
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/Store.vue